import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Icons from '../components/Icons';

export default function FeedbackPage() {
  const navigate = useNavigate();
  const [topic, setTopic] = useState('bug');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return toast.error('Please enter your feedback.');
    
    setSending(true);
    // Simulate API call
    setTimeout(() => {
      setSending(false);
      setMessage('');
      toast.success('Feedback sent successfully! Thank you.');
      setTimeout(() => navigate(-1), 1500);
    }, 1000);
  };

  return (
    <div className="custom-scroll page-enter" style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'var(--bg)', zIndex: 9999, overflowY: 'auto' }}>
      
      <button onClick={() => navigate(-1)} style={{ position: 'absolute', top: 30, right: 30, width: 44, height: 44, borderRadius: '50%', background: 'rgba(255,255,255,0.05)', color: 'var(--t2)', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10 }}>
        <Icons.X sz={20} />
      </button>

      <div style={{ maxWidth: 600, margin: '0 auto', padding: '80px 20px', color: 'var(--t2)', lineHeight: 1.6 }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h1 style={{ fontSize: 36, color: 'var(--t1)', marginBottom: 12, fontWeight: 800 }}>We're Listening.</h1>
          <p style={{ fontSize: 16, color: 'var(--t3)', maxWidth: 400, margin: '0 auto' }}>
            Report bugs, request new models, or tell us how we can make aiField Studio better for you.
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ background: 'var(--bg2)', padding: 30, borderRadius: 16, border: '1px solid var(--b2)' }}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'var(--t2)', fontWeight: 600, marginBottom: 8 }}>Topic</label>
            <select 
              value={topic} onChange={e => setTopic(e.target.value)}
              style={{ width: '100%', padding: '12px 16px', background: 'var(--bg)', border: '1px solid rgba(255,255,255,0.1)', color: 'var(--t1)', borderRadius: 10, outline: 'none', cursor: 'pointer' }}
            >
              <option value="bug">🐛 Report a Bug</option>
              <option value="feature">✨ Feature Request</option>
              <option value="model">🧠 AI Model Suggestion</option>
              <option value="billing">💳 Billing Issue</option>
              <option value="other">💬 General Feedback</option>
            </select>
          </div>

          <div style={{ marginBottom: 30 }}>
            <label style={{ display: 'block', fontSize: 13, color: 'var(--t2)', fontWeight: 600, marginBottom: 8 }}>Your Message</label>
            <textarea 
              value={message} onChange={e => setMessage(e.target.value)}
              placeholder="Tell us what's on your mind..."
              style={{ width: '100%', height: 160, padding: '16px', background: 'var(--bg)', border: '1px solid rgba(255,255,255,0.1)', color: 'var(--t1)', borderRadius: 10, outline: 'none', resize: 'none' }}
            />
          </div>

          <button type="submit" disabled={sending} style={{ 
            width: '100%', padding: '16px', background: 'linear-gradient(135deg, #a78bfa, #8b5cf6)', color: '#fff', 
            border: 'none', borderRadius: 12, fontWeight: 700, fontSize: 16, cursor: sending ? 'not-allowed' : 'pointer', opacity: sending ? 0.7 : 1 
          }}>
            {sending ? 'Sending...' : 'Submit Feedback'}
          </button>
        </form>

      </div>
    </div>
  );
}
